"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uxTreadDotcomConstants = require("@nike/ux-tread-dotcom-constants");
var _getWebshellclientLocale = _interopRequireDefault(require("../../../../../utils/get-webshellclient-locale"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* istanbul ignore file */

var getURLBase = function getURLBase() {
  var country = (0, _getWebshellclientLocale["default"])().country;
  var brand = _uxTreadDotcomConstants.NIKE_BRAND;
  var channel = _uxTreadDotcomConstants.NIKECOM_CHANNEL;
  return "".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/carts/v2/").concat(country.toUpperCase(), "/").concat(brand, "/").concat(channel);
};
var _default = exports["default"] = getURLBase;